import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FadeIn, SectionHeader } from "./Reveal";

const FAQS = [
    {
        q: "Czy wykonujecie małe zlecenia?",
        a: "Oczywiście. Drobne naprawy, regulacje i montaże to nasza codzienność — żadne zlecenie nie jest za małe. Chętnie przyjedziemy nawet na godzinną pracę.",
    },
    {
        q: "Czy wystawiacie fakturę?",
        a: "Tak, na życzenie klienta wystawiamy fakturę za wszystkie wykonane usługi. Wycena zawsze zawiera pełny, przejrzysty zakres kosztów.",
    },
    {
        q: "Jak szybko realizowane są usługi?",
        a: "Na kontakt odpowiadamy w ciągu 24 godzin. Drobne naprawy często realizujemy w ciągu kilku dni, a termin większych remontów ustalamy wspólnie podczas darmowej wyceny.",
    },
    {
        q: "Czy udzielacie gwarancji?",
        a: "Tak — na wszystkie wykonane przez nas prace udzielamy gwarancji. Jeśli cokolwiek wymaga poprawki, wracamy i naprawiamy to bez dodatkowych kosztów.",
    },
    {
        q: "Na jakim terenie działacie?",
        a: "Działamy w Krakowie i okolicach — dojeżdżamy do klientów w promieniu ok. 30–40 km (m.in. Wieliczka, Skawina, Zabierzów, Mogilany, Zielonki). Zadzwoń pod numer +48 512 913 717 i zapytaj o swój adres — na pewno się dogadamy.",
    },
    {
        q: "Ile kosztuje wycena?",
        a: "Wycena jest całkowicie darmowa i niezobowiązująca. Przyjeżdżamy, oglądamy zakres prac i przedstawiamy konkretną ofertę — decyzja należy do Ciebie.",
    },
];

export default function Faq() {
    return (
        <section id="faq" className="bg-mist py-24 md:py-32">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 md:px-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <SectionHeader index="06" eyebrow="FAQ" title="Pytania? Mamy odpowiedzi." />
                    <FadeIn delay={0.2}>
                        <p className="mt-8 text-sm leading-relaxed text-ink/55 md:text-base">
                            Nie znalazłeś odpowiedzi? Zadzwoń pod numer{" "}
                            <a href="tel:+48512913717" className="font-semibold text-ink underline decoration-gold decoration-2 underline-offset-4">
                                +48 512 913 717
                            </a>{" "}
                            — chętnie doradzimy.
                        </p>
                    </FadeIn>
                </div>
                <FadeIn delay={0.1} className="lg:col-span-7">
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-ink/10">
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${i}`}
                                    className="py-6 text-left font-display text-lg font-bold tracking-tight text-ink hover:text-ink/70 hover:no-underline md:text-xl"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-6 text-sm leading-relaxed text-ink/60 md:text-base">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </FadeIn>
            </div>
        </section>
    );
}
